// pages/RegistrationFuiteDonnees/components/UI/Button.tsx
import React from 'react';
import './Button.scss';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'link';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  label?: string;
  loadingText?: string; // Nouvelle prop pour texte personnalisé pendant le chargement
}

const Button: React.FC<ButtonProps> = ({
                                         children,
                                         variant = 'primary',
                                         fullWidth = false,
                                         loading = false,
                                         icon,
                                         size = 'medium',
                                         className = '',
                                         disabled,
                                         label,
                                         loadingText = 'Chargement...',
                                         ...props
                                       }) => {
  return (
    <div className="UI-btn">
      <button
        className={`btn btn--${variant} btn--${size} ${fullWidth ? 'btn--full-width' : ''} ${
          loading ? 'btn--loading' : ''
        } ${className}`}
        disabled={disabled || loading}
        aria-busy={loading}
        {...props}
      >
        {loading ? (
          <span className="btn__loader">
            <span className="btn__loader-spinner"></span>
            <span className="btn__loader-text">{loadingText}</span>
          </span>
        ) : (
          <>
            {icon && <span className="btn__icon">{icon}</span>}
            {label || children}
          </>
        )}
      </button>
    </div>
  );
};

export default Button;